import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "huong_dan_vien";

moduleApi.create = (dataForm) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.update = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

// moduleApi.listAllField = (dataFilter) => {
//   let api = {
//     module: moduleName,
//     type: "list",
//     value: {dataFilter, fields: "id,ho_ten,email,dien_thoai,gioi_tinh,ngay_sinh,giay_to,quoc_tich,dia_chi,avatar_id,the_hdv,ngoai_ngu,so_truong,thanh_tich,lich_su_hanh_nghe"}
//   };
//   return ApiService(api);
// };

moduleApi.delete = (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id }
  };
  return ApiService(api);
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id }
  };
  return ApiService(api);
};

moduleApi.findByIdAllField = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id, fields: "id,ho_ten,email,dien_thoai,gioi_tinh,ngay_sinh,giay_to,quoc_tich,dia_chi,avatar_id,the_hdv,ngoai_ngu,so_truong,thanh_tich,lich_su_hanh_nghe" }
  };
  return ApiService(api);
};

moduleApi.getListHuongDanVienDaDan = () => {
  let api = {
    module: "tour",
    type: "views",
    viewAction: "dashboard_getTourGuideStatistics",
  };
  return ApiService(api);
};

moduleApi.location = (id) => {
  let api = {
    module: "location",
    type: "list",
    value: {
      filters: "user_id=" + id,
    }
  };
  return ApiService(api);
};

export default moduleApi;
